import { Encoding, MarkTransform, MarkType } from '@mode-vegas/vegas';

export interface TransformItem {
  label: string;
  transform: MarkTransform;
}

const supportedMarkTypes: ReadonlyArray<MarkType> = [MarkType.Area, MarkType.Bar, MarkType.Line];

export function isSupportedMarkType(type: MarkType): type is MarkType.Area | MarkType.Bar | MarkType.Line {
  return supportedMarkTypes.includes(type);
}

export function getMarkLayerOptions(encoding: Encoding | undefined, markType: MarkType, seriesField?: string) {
  if (encoding === undefined) {
    return;
  }
  // Only supported types for now
  if (!isSupportedMarkType(markType)) {
    return;
  }

  // Create a default empty layer options to use if nothing is set
  const defaultLayerOptions = { type: markType };
  if (encoding.marks.channel === '*') {
    return encoding.marks.properties.options?.[markType] ?? defaultLayerOptions;
  }

  if (seriesField != null) {
    // If there is a seriesField, return the options for that layer
    const series = encoding.marks.series.find((s) => s.field === seriesField);
    return series === undefined ? undefined : (series.properties.options?.[markType] ?? defaultLayerOptions);
  }
  // If there is more than one layer, return undefined
  if (encoding.marks.series.length > 1) {
    return;
  }
  // Return the options for the first layer
  return encoding.marks.series[0].properties.options?.[markType] ?? defaultLayerOptions;
}

export function getMarks(encoding: Encoding | undefined, seriesField?: string) {
  if (encoding === undefined) {
    return [];
  }
  if (encoding.marks.channel === '*') {
    return [encoding.marks.properties];
  }

  if (seriesField != null) {
    // If there is a seriesField, return the series
    const series = encoding.marks.series.find((s) => s.field === seriesField);
    return series !== undefined ? [series.properties] : [];
  }
  // Return all the series marks
  return encoding.marks.series.map((s) => s.properties);
}
